import { useCart } from '@chordcommerce/react-autonomy';
import React, { useEffect, useState } from 'react';
import { Button } from 'theme-ui';
import SpinnerBar from '~/components/Spinner/loader';
import { Step } from '../ProductCard';
import useVariantAvailability from '~/hooks/components/use-variant-availability';
import addToCartPixel from '~/scripts/NBCU/addToCartPixel';

type Props = {
  sku: string;
  setCurrentStep: React.Dispatch<React.SetStateAction<Step>>;
  currentStep: Step;
};
const AddToCartButton = ({ sku, setCurrentStep, currentStep }: Props) => {
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const { addToCart } = useCart();

  const handleClick = async () => {
    if (currentStep === 'add-to-cart') {
      setIsAddingToCart(true);
      try {
        await addToCart({ sku, quantity: 1 });
        addToCartPixel();
        setIsAddingToCart(false);
        setCurrentStep('added-to-cart');
      } catch (error) {
        console.error(error);
      }
    }
    if (currentStep === 'out-of-stock') {
      setCurrentStep('stock-request');
    }
  };

  const { data: inStock, isLoading: isCheckingStock } = useVariantAvailability({ sku, shouldFetch: true });

  useEffect(() => {
    if (!inStock && !isCheckingStock) {
      setCurrentStep('out-of-stock');
    } else {
      setCurrentStep('add-to-cart');
    }
  }, [inStock, isCheckingStock, setCurrentStep]);

  const buttonLabel = currentStep === 'out-of-stock' ? 'Notify Me' : 'Add to Cart';
  const isLoading = isAddingToCart || isCheckingStock;
  return (
    <Button
      variant="bare"
      sx={{
        fontFamily: 'inherit',
        fontSize: '1.6rem',
        fontWeight: 500,
        lineHeight: 1,
        textTransform: 'capitalize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: '2rem',
        py: '0.8rem',
        background: currentStep === 'out-of-stock' ? 'white' : 'black',
        color: currentStep === 'out-of-stock' ? 'black' : 'white',
        border: '1px solid',
        borderColor: currentStep === 'out-of-stock' ? 'black' : 'transparent',
        borderRadius: '3rem',
        flex: '1 1 auto',
        ':disabled': {
          backgroundColor: 'cloud',
        },
      }}
      onClick={handleClick}
      disabled={isLoading}
    >
      {isLoading ? <SpinnerBar /> : buttonLabel}
    </Button>
  );
};

export default AddToCartButton;
